<script setup lang="ts">
import QrcodeVue from "qrcode.vue";
import { useParticipantStore } from "@/stores/eventParticipant";
import router from "@/router";
import apiClient from "@/utils/apiClient";
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import { formatEventDateRange } from "@/utils/dateRange";

const route = useRoute();

const id = import.meta.env.VITE_EVENT_ID;
const API_URL = import.meta.env.VITE_API_URL;
const participantData = useParticipantStore();
const event = ref<any>({});
const eventLoading = ref(true);

const organizationName = computed(() => {
  return [9, 10, 11, 12].includes(event.value.id)
    ? "BADAN PELAYANAN NASIONAL"
    : "JEDUTHUN SALVATION MINISTRY";
});

const qrForegroundColor = computed(() => {
  return event.value.color !== "#FFFFFF" ? event.value.color : "#7f1d1d";
});

const isPaymentProofRequired = computed(() => {
  return Boolean(event.value.send_payment_proof);
});

const eventEndpoint = computed(() => {
  return route.query.event ? `search/${route.query.event}` : id;
});

onMounted(() => {
  apiClient
    .get(API_URL + "/api/event/" + eventEndpoint.value)
    .then((response) => {
      event.value = response.data.event;
    })
    .finally(() => {
      eventLoading.value = false;
    });
});

const returnToPage = () => {
  router.push({
    path: "/",
    query: { event: route.query.event },
  });
};

const getDateRange = (
  startDate: string | Date,
  endDate: string | Date,
  timezone = 8,
) => {
  return formatEventDateRange(startDate, endDate, timezone);
};
</script>

<template>
  <main class="min-h-screen flex items-center justify-center flex-col pb-5">
    <div
      class="w-full lg:w-1/2 flex items-center flex-col justify-center py-5 px-5"
    >
      <h2 class="mx-auto text-lg md:text-xl text-center text-white font-bold">
        {{ organizationName }}
      </h2>
      <img
        v-if="event.logo_url"
        :src="event.logo_url || '#'"
        class="w-3/4 md:w-1/2"
      />
    </div>
    <p
      class="mx-auto text-center font-bold text-xl"
      :style="{ color: event.color }"
    >
      {{ event.event_name }}
    </p>

    <p
      v-if="!eventLoading"
      class="mx-auto text-lg text-center"
      :style="{ color: event.color }"
    >
      {{ getDateRange(event.event_start, event.event_end, event.timezone) }}
    </p>
    <p v-else class="mx-auto text-lg text-center" :style="{ color: '#9ca3af' }">
      Memuat informasi event...
    </p>

    <h2
      v-if="!eventLoading && !isPaymentProofRequired"
      class="font-bold mx-auto text-center mt-5 px-4 lg:px-0 text-red-800"
    >
      Harap screenshot halaman ini karena QR Code yang tertera akan digunakan
      untuk re-registrasi pada saat event berlangsung
    </h2>
    <div v-else-if="eventLoading" class="mt-5 text-center">
      <span class="loading loading-dots loading-md text-red-800"></span>
    </div>

    <div
      class="card w-80 bg-base-100 shadow-xl mx-auto my-5"
      v-for="(participant, index) in participantData.data"
      :key="index"
    >
      <div v-if="eventLoading" class="card-body items-center text-center">
        <span class="loading loading-dots loading-md"></span>
      </div>
      <div
        v-else-if="isPaymentProofRequired"
        class="card-body items-center text-center"
      >
        <div class="w-full mx-auto">
          <h2 class="card-title">
            {{ participant.name }}, Terima kasih telah register kegiatan
            {{ participantData.event.event_name }}!
          </h2>
          <p>Jenis Paket : {{ participantData.pckg.package_name }}</p>
          <div class="divider"></div>
          <p>
            Harap menunggu konfirmasi dari admin untuk pengecekan pembayaran
            1x24Jam.
          </p>
          <p class="font-bold">
            QR Code Peserta akan dikirimkan setelah pembayaran terkonfirmasi.
          </p>
          <p>Gbu😊</p>
        </div>
      </div>
      <div v-else class="card-body items-center text-center">
        <div class="w-full mx-auto">
          <qrcode-vue
            :value="participant.id"
            :foreground="qrForegroundColor"
            class="mx-auto p-2 bg-white"
            :size="200"
            render-as="svg"
          ></qrcode-vue>
        </div>
        <h2 class="card-title">
          {{ participant.name }}, Terima kasih telah register kegiatan
          {{ participantData.event.event_name }}!
        </h2>
        <p>Jenis Paket : {{ participantData.pckg.package_name }}</p>
        <div class="divider"></div>
        <p class="font-bold">
          QR code akan dipakai untuk melakukan re-registrasi di tempat
        </p>
        <p class="">
          QR code juga akan dikirimkan melalui email/WA yang anda masukkan
        </p>
        <div class="card-actions"></div>
      </div>
    </div>
    <button class="btn btn-primary" @click="returnToPage">
      Register Peserta Baru
    </button>
  </main>
</template>
